// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"f300c236","511":"96b995e6","673":"c51bb613"}[chunkId] + ".chunk.js";
};